import { useAuth } from "/imports/state/AuthContext";
import api from "/imports/api/client";
import useFetch from "/imports/hooks/useFetch";

/**
 * The active client's saved preferences (preferred sports / services / trainers
 * and time windows), used to power the slot views' "Suggested for you" section
 * and the "Use my preferences" filter shortcut. Fetched once per active client —
 * a small request independent of (and parallel to) the availability fetch, so it
 * never delays the slot grid. Returns empty arrays for guests or clients with no
 * preferences.
 */
export default function useClientPreferences(slug) {
  const { isAuthenticated, activeClientId } = useAuth();
  const { data } = useFetch(() => api.getUserPreferences(slug), [slug, activeClientId], { skip: !slug || !isAuthenticated });
  const prefs = data?.preferences;
  return {
    isAuthenticated,
    sports: prefs?.sports || [],
    services: prefs?.services || [],
    trainers: prefs?.trainers || [],
    locations: prefs?.locations || [],
    timeRanges: prefs?.timeRanges || []
  };
}
